import { createFragmentContainer, graphql } from "react-relay";
import JobEvent from "~/components/JobActivityTimeline/JobEvent";

type Props = {
  event: any;
  previousTimestamp: string | null | undefined;
};

function JobEventReserved({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>Job was reserved awaiting infrastructure to run it</JobEvent.Label>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventReserved, {
  event: graphql`
    fragment JobEventReserved_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `,
});
